import React, { ChangeEvent, FC, useState } from 'react'
import { Button, Checkbox, Input, Tabs } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox/Checkbox'
import cn from 'classnames'

import { ReactComponent as SearchIcon } from 'sources/images/appVideos/tab-search-icon.svg'
import { ReactComponent as DownArrowIcon } from 'sources/images/appVideos/tab-down-arrow.svg'

import Videos from './Videos'
import Playlists from './Playlists'
import OnePlaylistMediaItems from './OnePlaylistMediaItems'

import styles from './styles.module.scss'

interface IProps {
  youtubePlaylists: any
  uploadYoutubeMediaItems: any
  allMediaItemsInCategory: any
  addedMediaItems: []
  onSelectUploadMediaItem: (e: CheckboxChangeEvent) => void
  onSelectAllUploadMediaItem: (e: CheckboxChangeEvent) => void
  selectedUploadMediaItemsId: string[]
  onSearchUploadMediaItems: (e: ChangeEvent<HTMLInputElement>) => void
  isFiltered: boolean
  filteredMediaItems: any
  initCategoryMediaItems: null | []
  showcasesData: any
  setAllMediaItemsInCategory: any
  setEditCategoryDescription: any
  setIsChangeDescription: any
  uniqYoutubeChannelVideosWithoutCategory: any
  mediaPlaylists: any
  setIsChangeSync: any
  setMediaPlaylistData: any
  renderMediaItems: any
  scrollHandler: any
  fetching: boolean
  setIsOpenEditDescription: any
  setEditDescriptionMediaItems: any
  setCurrentPlaylistDescription: React.Dispatch<string>
  setOnePlaylistData: any
  onePlayListData: any
  setIsOnePlaylist: React.Dispatch<boolean>

  draggingUploadMediaItemRef: any
  handleDragStartUploadMediaItems: (e: any) => void
  handleDragEnterUploadMediaItems: (e: any) => void
  handleDragEndUploadMediaItems: (e: any) => void
  handleDragDropUploadMediaItems: (e: any) => void
}

const YoutubeAppVideos: FC<IProps> = ({
  youtubePlaylists,
  uploadYoutubeMediaItems,
  allMediaItemsInCategory,
  addedMediaItems,
  onSelectUploadMediaItem,
  onSelectAllUploadMediaItem,
  selectedUploadMediaItemsId,
  onSearchUploadMediaItems,
  isFiltered,
  filteredMediaItems,
  initCategoryMediaItems,
  showcasesData,
  setAllMediaItemsInCategory,
  setEditCategoryDescription,
  setIsChangeDescription,
  uniqYoutubeChannelVideosWithoutCategory,
  mediaPlaylists,
  setIsChangeSync,
  setMediaPlaylistData,
  renderMediaItems,
  scrollHandler,
  fetching,
  setIsOpenEditDescription,
  setEditDescriptionMediaItems,
  setCurrentPlaylistDescription,
  setOnePlaylistData,
  onePlayListData,
  setIsOnePlaylist,

  draggingUploadMediaItemRef,
  handleDragStartUploadMediaItems,
  handleDragEnterUploadMediaItems,
  handleDragEndUploadMediaItems,
  handleDragDropUploadMediaItems,
}) => {
  const [isVideosTab, setIsVideosTab] = useState(false)
  const [allUnImportedMediaItems, setAllUnImportedMediaItems] = useState<any>(
    []
  )

  const [isOpenPlaylistMediaItems, setIsOpenPlaylistMediaItems] =
    useState(false)

  // console.log(
  //   'uploadYoutubeMediaItems',
  //   uploadYoutubeMediaItems,
  //   selectedUploadMediaItemsId
  // )

  const operations = {
    right: (
      <div className={styles.tabOperations}>
        <Button className={styles.tabOperationsBtn} shape="round">
          <SearchIcon />{' '}
          <Input
            placeholder="Search"
            className={styles.searchField}
            onChange={onSearchUploadMediaItems}
          />
        </Button>
        <Button className={styles.tabOperationsBtn} shape="round">
          Recently added <DownArrowIcon />
        </Button>
        <Button className={styles.tabOperationsBtn} shape="round">
          <Checkbox
            className={styles.checkbox}
            onChange={onSelectAllUploadMediaItem}
            checked={
              renderMediaItems.length === selectedUploadMediaItemsId.length
            }
            // disabled={uploadYoutubeMediaItems.length === addedMediaItems.length}
          >
            Select all
          </Checkbox>
        </Button>
      </div>
    ),
  }

  const onCloseOnePlaylistVideos = (): void => {
    setIsOpenPlaylistMediaItems(false)
    setIsVideosTab(false)
    setIsOnePlaylist(false)
  }

  return (
    <Tabs
      defaultActiveKey="1"
      destroyInactiveTabPane
      className={cn(styles.tabs)}
      onChange={key => {
        if (key === '1') {
          setIsVideosTab(false)
          setIsOpenPlaylistMediaItems(false)
        } else {
          setIsVideosTab(true)
        }
      }}
      tabBarExtraContent={isVideosTab ? operations : null}
      onScroll={scrollHandler}
      data-tab={`${isVideosTab ? 'videos' : 'playlists'}`}
    >
      <Tabs.TabPane
        className={styles.tabPlaylists}
        tab={`Playlists (${youtubePlaylists.length})`}
        key="1"
      >
        {isOpenPlaylistMediaItems ? (
          <OnePlaylistMediaItems
            onePlayListData={onePlayListData}
            onCloseOnePlaylistVideos={onCloseOnePlaylistVideos}
            allMediaItemsInCategory={allMediaItemsInCategory}
            addedMediaItems={addedMediaItems}
            onSelectUploadMediaItem={onSelectUploadMediaItem}
            selectedUploadMediaItemsId={selectedUploadMediaItemsId}
            initCategoryMediaItems={initCategoryMediaItems}
            allUnImportedMediaItems={allUnImportedMediaItems}
            renderMediaItems={renderMediaItems}
            draggingUploadMediaItemRef={draggingUploadMediaItemRef}
            handleDragStartUploadMediaItems={handleDragStartUploadMediaItems}
            handleDragEnterUploadMediaItems={handleDragEnterUploadMediaItems}
            handleDragEndUploadMediaItems={handleDragEndUploadMediaItems}
            handleDragDropUploadMediaItems={handleDragDropUploadMediaItems}
          />
        ) : (
          <Playlists
            youtubePlaylists={youtubePlaylists}
            showcasesData={showcasesData}
            initCategoryMediaItems={initCategoryMediaItems}
            allMediaItemsInCategory={allMediaItemsInCategory}
            setAllMediaItemsInCategory={setAllMediaItemsInCategory}
            setEditCategoryDescription={setEditCategoryDescription}
            setIsChangeDescription={setIsChangeDescription}
            setAllUnImportedMediaItems={setAllUnImportedMediaItems}
            mediaPlaylists={mediaPlaylists}
            setIsChangeSync={setIsChangeSync}
            setMediaPlaylistData={setMediaPlaylistData}
            setIsOpenEditDescription={setIsOpenEditDescription}
            setEditDescriptionMediaItems={setEditDescriptionMediaItems}
            setIsOpenPlaylistMediaItems={setIsOpenPlaylistMediaItems}
            setOnePlaylistData={setOnePlaylistData}
            setCurrentPlaylistDescription={setCurrentPlaylistDescription}
            setIsVideosTab={setIsVideosTab}
            setIsOnePlaylist={setIsOnePlaylist}
          />
        )}
      </Tabs.TabPane>
      {!isOpenPlaylistMediaItems && (
        <Tabs.TabPane
          className={styles.tabVideos}
          tab={`Videos (${uploadYoutubeMediaItems.length})`}
          key="2"
        >
          <Videos
            isFiltered={isFiltered}
            initCategoryMediaItems={initCategoryMediaItems}
            filteredMediaItems={filteredMediaItems}
            uploadYoutubeMediaItems={uploadYoutubeMediaItems}
            addedMediaItems={addedMediaItems}
            selectedUploadMediaItemsId={selectedUploadMediaItemsId}
            onSelectUploadMediaItem={onSelectUploadMediaItem}
            onSelectAllUploadMediaItem={onSelectAllUploadMediaItem}
            allMediaItemsInCategory={allMediaItemsInCategory}
            allUnImportedMediaItems={allUnImportedMediaItems}
            uniqYoutubeChannelVideosWithoutCategory={
              uniqYoutubeChannelVideosWithoutCategory
            }
            renderMediaItems={renderMediaItems}
            scrollHandler={scrollHandler}
            fetching={fetching}
            draggingUploadMediaItemRef={draggingUploadMediaItemRef}
            handleDragStartUploadMediaItems={handleDragStartUploadMediaItems}
            handleDragEnterUploadMediaItems={handleDragEnterUploadMediaItems}
            handleDragEndUploadMediaItems={handleDragEndUploadMediaItems}
            handleDragDropUploadMediaItems={handleDragDropUploadMediaItems}
          />
        </Tabs.TabPane>
      )}
    </Tabs>
  )
}

export default YoutubeAppVideos
